// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IChecksResponseAggregatorDto } from './IChecksResponseAggregatorDto';
import {
    IChecksResponseAggregatorDtoFromJSON,
    IChecksResponseAggregatorDtoFromJSONTyped,
    IChecksResponseAggregatorDtoToJSON,
    IChecksResponseAggregatorDtoToJSONTyped,
} from './IChecksResponseAggregatorDto';

/**
 * 
 * @export
 * @interface IChecksResponseAggregatorDtoPage
 */
export interface IChecksResponseAggregatorDtoPage {
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IChecksResponseAggregatorDto>}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    content?: Array<IChecksResponseAggregatorDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IChecksResponseAggregatorDtoPage
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the IChecksResponseAggregatorDtoPage interface.
 */
export function instanceOfIChecksResponseAggregatorDtoPage(value: object): value is IChecksResponseAggregatorDtoPage {
    return true;
}

export function IChecksResponseAggregatorDtoPageFromJSON(json: any): IChecksResponseAggregatorDtoPage {
    return IChecksResponseAggregatorDtoPageFromJSONTyped(json, false);
}

export function IChecksResponseAggregatorDtoPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): IChecksResponseAggregatorDtoPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IChecksResponseAggregatorDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function IChecksResponseAggregatorDtoPageToJSON(json: any): IChecksResponseAggregatorDtoPage {
    return IChecksResponseAggregatorDtoPageToJSONTyped(json, false);
}

export function IChecksResponseAggregatorDtoPageToJSONTyped(value?: IChecksResponseAggregatorDtoPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IChecksResponseAggregatorDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

